import { Component } from '@angular/core';

import { HisAuthService } from 'hisng';
import { SEARCH_CONFIG_UNITS_BY_PERSON } from 'app/cs/psv/common/model/searchConstants';

@Component( {
    selector: 'psv-unit-search-form',
    templateUrl: './unit-search-form.component.html'
} )
export class UnitSearchFormComponent {
    readonly SEARCH_CONFIG_UNITS_BY_PERSON = SEARCH_CONFIG_UNITS_BY_PERSON;
    constructor( public auth: HisAuthService ) { }
}
